import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [dark, setDark] = useState(() => {
    // Check localStorage first, then check document attribute
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      return storedTheme === 'dark';
    }
    const docTheme = document.documentElement.getAttribute('data-bs-theme');
    return docTheme === 'dark';
  });

  useEffect(() => {
    // Update document attribute and body classes
    document.documentElement.setAttribute('data-bs-theme', dark ? 'dark' : 'light');
    document.body.className = dark ? 'dark-mode' : 'light-mode';
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  const toggleTheme = () => {
    setDark(!dark);
  };

  return (
    <ThemeContext.Provider value={{ dark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
